import axios from 'axios';
import {AxiosInstance} from "axios";


import {REACT_APP_API_URL} from "../config";
import toastStore from "../store/ToastStore";
import locale, {translateApiMessage} from "../locale";


const $host: AxiosInstance = axios.create({
    baseURL: REACT_APP_API_URL
})

const $authHost: AxiosInstance = axios.create({
    baseURL: REACT_APP_API_URL
})


const authInterceptor = (config: any) => {
    config.headers.authorization = `Bearer ${localStorage.getItem('token')}`;
    return config;
}

$authHost.interceptors.request.use(authInterceptor)


// Global "operation succeeded/failed" toast, wired at the axios level so it
// covers every API call in the app — including ones a page never wired its
// own feedback for — without touching each call site. Every http/*API.ts
// wrapper goes through one of these two instances, so this is the one place
// that sees them all.
//
// Only mutating requests toast; GETs are passive background/refetch traffic
// (WS-triggered refetches, page-load fetches) and would just be noise.
const MUTATING_METHODS = new Set(['post', 'put', 'delete', 'patch']);

// Endpoint responses are inconsistent in shape across the backend — some
// return {message: '...'}, some a bare string, some the raw created/updated
// entity with no message at all. Handle what we can, fall back generically
// rather than dumping raw JSON into a toast.
const messageFrom = (data: any, fallback: string): string => {
    if (typeof data === 'string' && data.trim()) return data;
    if (data && typeof data === 'object' && typeof data.message === 'string' && data.message.trim()) {
        return data.message;
    }
    return fallback;
};

const attachToastInterceptor = (instance: AxiosInstance) => {
    instance.interceptors.response.use(
        (response) => {
            const method = response.config.method?.toLowerCase();
            if (method && MUTATING_METHODS.has(method)) {
                const message = messageFrom(response.data, locale.toast.genericSuccess);
                toastStore.push(translateApiMessage(message), 'success');
            }
            return response;
        },
        (error) => {
            const method = error.config?.method?.toLowerCase();
            if (method && MUTATING_METHODS.has(method)) {
                const message = messageFrom(error.response?.data, error.message || locale.toast.genericError);
                toastStore.push(translateApiMessage(message), 'error');
            }
            return Promise.reject(error);
        },
    );
};

attachToastInterceptor($host);
attachToastInterceptor($authHost);

export {
    $host,
    $authHost
}
